import React, { useState } from "react";
import { Bell, Settings } from "lucide-react";
import { Link } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import NotificationDropdown from "../../screens/admin/dashboard/notifications/NotificationDropdown";
import "../../assets/css/layout/admin/Header.css";

const Header = () => {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const unreadCount = 3;

  const toggleNotifications = () => {
    setIsNotificationOpen(!isNotificationOpen);
  };

  return (
    <header className="adh-header">

      {/* LEFT SIDE */}
      <div className="adh-header-left">
        <h1 className="adh-welcome-text">Welcome Admin</h1>
      </div>

      {/* RIGHT SIDE */}
      <div className="adh-header-right">

        {/* Notifications with Dropdown */}
        <div className="adh-notification-wrapper">
          <button
            className="adh-notifications-btn"
            title="Notifications"
            onClick={toggleNotifications}
          >
            <div className="adh-notification-icon-wrapper">
              <Bell size={20} />

              {unreadCount > 0 && (
                <span className="adh-notification-badge">
                  {unreadCount}
                </span> 
              )}
            </div>
          </button>

          {/* Notification Dropdown */}
          <NotificationDropdown 
            isOpen={isNotificationOpen}
            onClose={() => setIsNotificationOpen(false)}
          />
        </div>

        {/* Profile */}
        <Link
          to="/admin/profile"
          className="adh-profile-btn"
          title="Profile"
        >
          <FaUserCircle size={26} />
        </Link>

      </div>
    </header>
  );
};

export default Header;